//파일명 확인
export const downloadFile = (file, fileNm, filedoc) => {
  let blob = new Blob([file.data]);
  let fileName = `${fileNm}.${filedoc}`;

  if (window.navigator.msSaveOrOpenBlob) {
    // IE 10+는 해당 함수 제공
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.target = '_self';
    if (fileName) link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(link); //메모리 누수 방지
  }
};
